import type { ReactNode } from 'react';

import { UnsavedChangesModalProvider } from '../contexts/UnsavedChangesContext';

/** Wraps modal form content so hooks like `useRequestLeave` work inside antd portals. */
export function wrapGuardedFormModalContent(content: ReactNode): ReactNode {
  return <UnsavedChangesModalProvider>{content}</UnsavedChangesModalProvider>;
}
